import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import styled from 'styled-components';
import { Typography, Button, Error as ErrorBase } from '@figure/frontlib-gui';
import { FormErrorHandler } from 'shared/components';
import IDFormSection from './IDFormSection';
import IDType from './IDType';
import { initialValues, validationSchema } from './formik';

const DisclaimerText = styled(Typography.SmallBodyGrey)`
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
`;

const ButtonGroup = styled.div`
  text-align: center;
`;

const Error = styled(ErrorBase)`
  margin-top: 8px;
`;

const IDUploadForm = ({ handleResetType, handleSubmit }) => {
  const { values, errors, touched, handleSubmit: handleFormikSubmit, setFieldValue } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => handleSubmit(values.tempFile),
  });

  const handleReset = async () => {
    await setFieldValue('tempFile', { uuid: '', file: null, type: '' });
    setFieldValue('imageTooLarge', false);
  };

  return (
    <>
      <FormErrorHandler errors={errors} touched={touched} />
      <form onSubmit={handleFormikSubmit} noValidate={true}>
        <IDType
          values={values}
          touched={touched}
          errors={errors}
          setFieldValue={setFieldValue}
          handleResetType={() => {
            handleResetType();
            handleReset();
          }}
        />

        {values.type && (
          <IDFormSection
            values={values}
            errors={errors}
            touched={touched}
            setFieldValue={setFieldValue}
            handleReset={handleReset}
          />
        )}

        <Error>{errors.imageTooLarge || ''}</Error>

        <DisclaimerText>
          CUSTOMER IDENTIFICATION PROGRAM NOTICE. In order to help the government fight the funding
          of terrorism, money laundering activities, and identity theft, the USA PATRIOT Act
          requires all financial institutions to obtain, verify, and record information that
          identifies each person that opens an account. What that means to you: When you open an
          account, we will ask for your name, street address, taxpayer identification number, date
          of birth, and other information that will allow us to identify you. We will also ask to
          see an unexpired, government issued photo ID or similar document
        </DisclaimerText>

        <ButtonGroup>
          <Button primary large type="submit" data-test-id="upload-continue">
            Upload and continue
          </Button>
        </ButtonGroup>
      </form>
    </>
  );
};

IDUploadForm.propTypes = {
  handleResetType: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default IDUploadForm;
